import { format, utcToZonedTime } from 'date-fns-tz'

export const insertArrayItem = function <T>(array: T[], index: number, item: T[]) {
	const newArray = array.slice()
	newArray.splice(index, 0, ...item)
	return newArray
}

export const insertItem = function <T>(array: T[], index: number, item: T) {
	const newArray = array.slice()
	newArray.splice(index, 0, item)
	return newArray
}

export const removeItem = function <T>(array: T[], index: number) {
	const newArray = array.slice()
	newArray.splice(index, 1)
	return newArray
}

export const removeItemByVal = function <T>(array: T[], val: T) {
	return array.filter((e) => e !== val)
}

export const isValidDate = (dateString: string) => {
	const regEx = /^\d{4}-\d{2}-\d{2}$/
	if (!dateString.match(regEx)) return false
	const d = new Date(dateString)
	const dNum = d.getTime()
	if (!dNum && dNum !== 0) return false
	return d.toISOString().slice(0, 10) === dateString
}

export const initArray = <T>(length: number, value: T | null = null) => {
	const resultArr = []
	for (let i = 0; i < length; i += 1) {
		resultArr.push(value)
	}
	return resultArr
}

export const convertDayArrToNumArr = (arr: string[]): boolean[] => {
	const resultArr = initArray(7, false) as boolean[]
	const dayArr = arr
	if (Array.isArray(arr)) {
		for (let i = 0; i < dayArr.length; i += 1) {
			if (typeof dayArr[i] === 'string') {
				const currDay = dayArr[i].toLowerCase()
				switch (currDay) {
					case 'sun':
						resultArr[0] = true
						break
					case 'mon':
						resultArr[1] = true
						break
					case 'tue':
						resultArr[2] = true
						break
					case 'wed':
						resultArr[3] = true
						break
					case 'thu':
						resultArr[4] = true
						break
					case 'fri':
						resultArr[5] = true
						break
					case 'sat':
						resultArr[6] = true
						break
					default:
						break
				}
			}
		}
		return resultArr
	}
	return []
}

export const formatDate = (date: string | Date, separator = '-') => {
	const d = date ? new Date(date) : new Date()
	let month = `${d.getMonth() + 1}`
	let day = `${d.getDate()}`
	const year = d.getFullYear()

	if (month.length < 2) month = `0${month}`
	if (day.length < 2) day = `0${day}`

	return [year, month, day].join(separator)
}

export const getDateByTimezone = (
	timezone: string,
	dataFormat: string,
	date: Date | string = new Date(),
	// separator = '-',
	// showTime = false,
): string => {
	const zonedDate = utcToZonedTime(date, 'Asia/Seoul')

	// const dataFormat = showTime
	// 	? `yyyy${separator}MM${separator}dd hh:mm:ss`
	// 	: `yyyy${separator}MM${separator}dd`
	const formattedOutput: string = format(zonedDate, dataFormat, {
		timeZone: timezone,
	})
	return formattedOutput
}

export const getDatesByDay = (
	startDate: Date | string = new Date(),
	endDate: Date | string = new Date(),
	dayArr = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
) => {
	const resultDateList = []
	const dayNumArr = convertDayArrToNumArr(dayArr)

	const currDateObj = typeof startDate === 'string' ? new Date(startDate) : startDate
	const endDateObj = typeof endDate === 'string' ? new Date(endDate) : endDate
	while (currDateObj <= endDateObj) {
		const currDay = currDateObj.getDay()
		if (dayNumArr[currDay]) {
			resultDateList.push(formatDate(currDateObj))
		}
		currDateObj.setDate(currDateObj.getDate() + 1)
	}
	return resultDateList
}

export const convertViewPortWidthToPixel = (vw: number) =>
	Math.round(window.innerWidth / (100 / vw))

export const convertViewPortHeightToPixel = (vh: number) =>
	Math.round(window.innerHeight / (100 / vh))

export const isValidEmail = (value: string) => {
	const emailRegExp =
		/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i

	return emailRegExp.test(value)
}

export const formatPriceByLocale = (price: number, local: string, options = {}) => {
	return new Intl.NumberFormat(local, options).format(price)
}

export const formatPhoneNumber = (number: string, separator = '-', wrapPreNum = false) => {
	let numberArr = null
	if (number.length === 10) {
		numberArr = number.match(/^(\d{3})(\d{3})(\d{4})$/)
	} else if (number.length === 11) {
		numberArr = number.match(/^(\d{3})(\d{4})(\d{4})$/)
	}

	if (Array.isArray(numberArr)) {
		const preNum = numberArr[1]
		const middleNum = numberArr[2]
		const endNum = numberArr[3]
		if (wrapPreNum) {
			return `(${preNum}) ${middleNum}${separator}${endNum}`
		}
		return preNum + separator + middleNum + separator + endNum
	}
	return null
}

export const copyTxt = (copyText: string): Promise<void> => {
	return navigator.clipboard.writeText(copyText)
}

export const priceFormatter = (price: number | string | undefined): string => {
	if (price === undefined) {
		return ''
	}

	const priceNum = typeof price === 'number' ? price : Number.parseInt(price, 10)

	return !Number.isNaN(priceNum) ? new Intl.NumberFormat().format(priceNum) : ''
}
